import type { AudioBookLinkResponse } from "shared";

export interface NormalizedAudioSourceResponse {
    kind: "storage" | "external";
    value: string;
    validUntil?: number;
    accessId?: string;
    downloadable?: boolean;
    version?: 2;
}

export function normalizeAudioSourceResponse(
    data: unknown,
    legacyKind: "storage" | "external"
): NormalizedAudioSourceResponse {
    if (typeof data === "string" && data) {
        return { kind: legacyKind, value: data, validUntil: undefined, accessId: undefined };
    }
    const response = data as Partial<AudioBookLinkResponse> | null;
    if (
        response?.version !== 2 ||
        typeof response.value !== "string" ||
        !response.value ||
        (response.kind !== "storage" && response.kind !== "external") ||
        typeof response.validUntil !== "number" ||
        !Number.isFinite(response.validUntil) ||
        typeof response.accessId !== "string" ||
        !response.accessId ||
        typeof response.downloadable !== "boolean"
    ) {
        throw new Error("Ugyldig lydkilde");
    }
    return response as AudioBookLinkResponse;
}
